module.exports = __webpack_public_path__ + "img/toux.7f2dc86e.png";